import _ from 'lodash';
import * as mobx from 'mobx';
import { CoreFetch, MessageApi, MessageLinkEntityType } from '@enter/core';
import { handleError, IMessageDetail, RootStore } from '../../stores';

export class MessagingPresenter {
    @mobx.observable.ref isOpen: boolean = false;
    @mobx.observable.ref isComposeOpen: boolean = false;
    @mobx.observable.ref isDetailLoading: boolean = false;
    @mobx.observable.ref messageDetails: IMessageDetail | undefined;

    constructor(private rootStore = new RootStore()) {
        mobx.makeObservable(this);
    }

    @mobx.action
    public setOpen(isOpen: boolean) {
        this.isOpen = isOpen;

        if (isOpen === false) {
            this.closeDetails();
        }
    }

    @mobx.action
    public setComposeOpen(isComposeOpen: boolean) {
        this.isComposeOpen = isComposeOpen;

        if (isComposeOpen === false) {
            this.closeDetails();
        }
    }

    @mobx.action
    public async openMessage(messageId: string) {
        this.isDetailLoading = true;

        try {
            const detail = await this.rootStore.messageStore.loadMessageDetail(messageId);

            if (!detail || _.isEqual(detail, this.messageDetails)) {
                return;
            }

            mobx.runInAction(() => {
                this.messageDetails = detail;
            });
        } catch (err) {
            handleError(err);
        } finally {
            mobx.runInAction(() => {
                this.isDetailLoading = false;
            });
        }
    }

    @mobx.action
    public async linkEntityToMessage(id: string, entityType: MessageLinkEntityType, entityIds: string[]): Promise<void> {
        try {
            // Call API to link entity first
            await CoreFetch(MessageApi).postProviderMessageLink({
                id,
                providerMessageLinkPayload: { entityType, entityIds }
            });
            
            // Reload message details from store to get updated links
            const detail = await this.rootStore.messageStore.loadMessageDetail(id);
            
            // Update presenter with fresh data
            mobx.runInAction(() => {
                this.messageDetails = detail;
            });
        } catch (error) {
            console.error('Failed to link entity:', error);
            throw error;
        }
    }

    @mobx.action
    public async unlinkEntityFromMessage(id: string, entityType: MessageLinkEntityType, entityIds: string[]): Promise<void> {
        try {
            // Call API to unlink entity first
            await CoreFetch(MessageApi).postProviderMessageUnlink({
                id,
                providerMessageLinkPayload: { entityType, entityIds }
            });
            
            // Reload message details from store to get updated links
            const detail = await this.rootStore.messageStore.loadMessageDetail(id);
            
            // Update presenter with fresh data
            mobx.runInAction(() => {
                this.messageDetails = detail;
            });
        } catch (error) {
            console.error('Failed to unlink entity:', error);
            throw error;
        }
    }

    @mobx.action
    public closeDetails() {
        this.messageDetails = undefined;
    }
}
